module.exports = __webpack_public_path__ + "static/media/protix.94110a9d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/protix.webp
// module id = 386
// module chunks = 0